import api from '../../..'
import serviceTasks from './serviceTask'

const requests = {
    create: async ({
        patientId,
        practiceId,
        generalPractitionerId,
        urgencyId,
        requestReceivedDate,
        completedDate,
        disciplineId,
        responsibleTeamId,
        hrsToComplete,
        practiceAcknowledged,
        currentGPMPLessThan12
    }) => {
        var response = await api.post(`/maarima/Request`, {
            patientId,
            practiceId,
            generalPractitionerId,
            urgencyId,
            requestReceivedDate,
            completedDate,
            disciplineId,
            responsibleTeamId,
            hrsToComplete,
            practiceAcknowledged,
            currentGPMPLessThan12
        })

        return response.data
    },
    update: async (payload) => {
        var packet = FormData.fromObject({
            id: payload.id,
            generalPractitionerId: payload.generalPractitionerId,
            urgencyId: payload.urgencyId,
            completedDate: payload.completedDate,
            disciplineId: payload.disciplineId,
            responsibleTeamId: payload.responsibleTeamId,
            hrsToComplete: payload.hrsToComplete,
            practiceAcknowledged: payload.practiceAcknowledged,
            currentGPMPLessThan12: payload.currentGPMPLessThan12,
            isClaimed: payload.isClaimed,
            iptaasForm: payload.iptaasForm
                ? {
                      ...payload.iptaasForm,
                      id: payload.iptaasForm.id ? payload.iptaasForm.id : null,
                      attachment:
                          payload.iptaasForm.attachment && payload.iptaasForm.attachment.file
                  }
                : null,
            escortForm: payload.escortForm
                ? {
                      ...payload.escortForm,
                      id: payload.escortForm.id ? payload.escortForm.id : null
                  }
                : null
        })

        var response = await api.put(`/maarima/Request/${payload.id}`, packet, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })

        return response.data
    },

    delete: async (id) => {
        var response = await api.delete(`/maarima/Request/${id}`)
        return response.data
    },

    fetch: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/Request`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data
    },
    fetchInactive: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/Request/inactive`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data
    },

    fetchActive: async ({ search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/Request/active`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data
    },
    fetchById: async (id) => {
        var response = await api.get(`/maarima/Request/${id}`)
        return response.data
    },
    fetchTasks: async ({ id, search, sortKey, sortType, pageSize, pageNo }) => {
        var response = await api.get(`/maarima/Request/${id}/Task`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo
            }
        })
        return response.data
    },
    fetchTaskById: async (id) => {
        var response = await api.get(`/maarima/Request/${id}/Task/${id}`)
        return response.data
    },

    updateStatus: async (id, statusId, completedDate) => {
        var response = await api.put(`/maarima/Request/${id}/Status/${statusId}`, {
            completedDate: completedDate
        })

        return response.data
    },

    serviceTask: serviceTasks
}

export default requests
